import { SystemStyleObject } from '@chakra-ui/react';
import {
  CO_WRITER_BAR_KEY,
  getMaxWidth,
  getMinWidth,
  getWidth,
} from 'app/utils/hooks';

export const getStyles = ({
  forceCompactMode,
  isDragging,
}: {
  forceCompactMode: boolean;
  isDragging: boolean;
}) => {
  const rootSx = {
    zIndex: 1,
    ml: 2,
    flexShrink: 0,
    position: 'relative',
    width: getWidth(CO_WRITER_BAR_KEY),
    minW: getMinWidth(CO_WRITER_BAR_KEY),
    maxW: getMaxWidth(CO_WRITER_BAR_KEY),
  };

  const wrapperSx = {
    position: 'absolute',
    width: 'inherit',
    maxWidth: 'inherit',
  };

  const contentSx = {
    alignItems: 'baseline',
    width: 'inherit',
    gap: 1,
    overflow: 'hidden',
  };

  const cardSx = {
    w: 'full',
    pt: 6,
    pb: 4,
    px: 2,
    gap: 1,
    rounded: 6,
  };

  const sidebarResizeLineSx: SystemStyleObject = {
    position: 'absolute',
    left: 0,
    height: 'full',
    px: 0.5,
    zIndex: 1,
    '& div': {
      w: 0.5,
      h: 'full',
      bg: isDragging ? 'B.80' : 'none',
    },
    _hover: {
      '& div': {
        ...(!forceCompactMode ? { bg: 'B.80' } : {}),
      },
    },
  };

  return { rootSx, wrapperSx, contentSx, cardSx, sidebarResizeLineSx };
};
